// import React from "react";
// import { Stack, ActionButton } from "office-ui-fabric-react";
// import { get } from "lodash";

// const AssignmentField = ({ item, passConfig }) => {

//   const {setRenderInPanel} = passConfig;

//   const X = (<><div>{JSON.stringify(item)}</div>
//     <ActionButton onClick={() => setRenderInPanel(null)} text="Close"/>
//   </>
//   );

//   return (
//     <div>

//     <ActionButton text="set" onClick={() => {
//       setRenderInPanel(X)
//     }}/>
//     </div>
//   );
// };

const RenderColumns = (/* primaryKey */) => [
  ["Name", "name"],
  ["City", "city"],
  ["State / Country", ["state", "country"]],
  ["Login Email Id", "email"],
  // ["Set", (item, passConfig) => (
  //   <AssignmentField item={item} passConfig={passConfig} />
  // ) ],
  ["Status", (user) => (user.inactive ? "Deactivated" : "Active")],
];
export default RenderColumns;
